import Footer from 'components/footer';
import PreLoading from 'components/pre-loading';


const DrgnWorld = () => {
  return (
    <>
      <PreLoading label="DRGN World" />
      <div style={{height: '70px'}}></div>
      <iframe src="https://app.drgn88.world/" title='DRGN World' style={{height: '200vh', width: '100%', border: 'none', 'display': "block" }} id="drgnworld-iframe">
      </iframe>
      <Footer />
    </>
  );
};
export default DrgnWorld;
